import { useEffect } from "react"
import { useLazyGetPhaseNodetailsQuery } from "../../../services/announceElection"
import EpbPinUnitDownload from "../../Officers/UnitOfficer/EpbPinUnitDownload"

function UnitOfficerDashboard() {
  const [phaseNo,datap] = useLazyGetPhaseNodetailsQuery()
 
  useEffect(()=>{
    phaseNo().then((res)=>{
      var data = []
  res?.data?.payload?.map((item)=>{
    data.push(item?.phaseNo)
  })
  let string = JSON.stringify(data)
  localStorage.setItem("phaseList",string)
    })
  },[])

  return (
    <>
     <EpbPinUnitDownload />
    </>
  )
}

export default UnitOfficerDashboard
